import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
	putApiCodelistManagementDownloadConfigsId,
	UpdateInstitutionDownloadConfigRequest,
} from "Infrastructure/Api/Api";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { DOWNLOAD_CONFIGS_QUERY_KEY } from "../Queries/useDownloadConfigsQuery";

type UpdateParams = {
	id: number;
	data: UpdateInstitutionDownloadConfigRequest;
};

export function useUpdateDownloadConfigMutation() {
	const queryClient = useQueryClient();
	const showSnackbar = useSnackbar();

	return useMutation({
		mutationFn: ({ id, data }: UpdateParams) =>
			putApiCodelistManagementDownloadConfigsId(data, id),
		onSuccess: (response) => {
			if (response.status === 200) {
				showSnackbar("Konfigurace uložena", "success");
				queryClient.invalidateQueries({
					queryKey: [DOWNLOAD_CONFIGS_QUERY_KEY],
				});
			} else if (response.status === 404) {
				showSnackbar("Konfigurace nenalezena", "error");
			} else {
				showSnackbar("Chyba při ukládání konfigurace", "error");
			}
		},
		onError: () => {
			showSnackbar("Chyba při ukládání konfigurace", "error");
		},
	});
}
